import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Colors from '../../../../layout/theme/utils/colors';

export default makeStyles((theme: Theme) =>
  createStyles({
    boxContainer: {
      height: 46,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      '&:hover': {
        backgroundColor: Colors.light_gray,
      },
    },
    span: {
      flex: 1,
    },
    cancelButton: {
      marginRight: theme.spacing(1),
      border: `1px solid ${Colors.navy}`,
      backgroundColor: 'transparent',
      color: Colors.navy,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    editIcon: {
      height: 17,
      width: 17,
      marginRight: theme.spacing(2),
    },
    editIconDisable: {
      color: Colors.gray,
    },
    iconButton: {
      backgroundColor: 'unset',
      '&:hover': {
        color: 'unset',
        backgroundColor: 'unset',
      },
    },
    deleteIcon: {
      color: Colors.error_red,
    },
  }),
);
